import React from "react";

function PropsLiveSkeleton({ tabs = 4, groups = 5 }: { tabs?: number; groups?: number }) {
    return (
        <>
            <div className="prop-live-tabs props-live-skeleton-tabs" aria-hidden="true" aria-busy="true">
                {Array.from({ length: tabs }).map((_, i) => (
                    <div key={i} className="props-live-tab">
                        <span className="props-live-skeleton-tab" />
                    </div>
                ))}
            </div>
            <div className="prop-live-content props-live-skeleton-content" aria-hidden="true">
                {Array.from({ length: groups }).map((_, i) => (
                    <div key={i} className="group-item-props props-live-skeleton-group">
                        <div className="group-header-props">
                            <span className="props-live-skeleton-line props-live-skeleton-line--title" />
                            <span className="props-live-skeleton-arrow" />
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export default PropsLiveSkeleton;
